import { FGSelectInput, IFGSelectInputProps } from "nsitools-react";
import * as React from "react";
import { useGlobalData } from "../../../contexts";
import { useReferential } from "../../../hooks/useReferential";

export interface IFGWorkbookTypeSelectProps extends IFGSelectInputProps<any> {
  name: string;
  label: string;
  dogId: number;
}

export const FGWorkbookTypeSelect: React.FunctionComponent<IFGWorkbookTypeSelectProps> = ({ name, label, dogId }) => {
  const { currentLanguage } = useGlobalData();

  const [workbookTypes, wtloading] = useReferential(
    (a) => a.getWorkbookTypes(currentLanguage.languageId, dogId),
    false,
    []
  );

  return <FGSelectInput name={name} label={label} items={workbookTypes} loading={wtloading} />;
};
